import styles from './FilterChips.module.css';

export interface ChipOption {
  value: string;
  label: string;
}

export interface FilterChipsProps {
  options: ChipOption[];
  selected: string[];
  onChange: (selected: string[]) => void;
  multi?: boolean;
}

export function FilterChips({
  options,
  selected,
  onChange,
  multi = true,
}: FilterChipsProps): JSX.Element {
  const toggle = (value: string): void => {
    if (multi) {
      if (selected.includes(value)) onChange(selected.filter((s) => s !== value));
      else onChange([...selected, value]);
    } else {
      onChange(selected.includes(value) ? [] : [value]);
    }
  };
  return (
    <div className={styles.row}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={[styles.chip, selected.includes(opt.value) && styles.active]
            .filter(Boolean)
            .join(' ')}
          onClick={() => toggle(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
